import { type PlatformEvent } from '../services/analytics/types';
import { LogDevMessageKinds, makeLogDevMessage } from './make-log-dev-message';

export const logEventInDevMode = makeLogDevMessage<PlatformEvent>(
  LogDevMessageKinds.analytics,
  (event) =>
    Array.from(new Set([event.type, event.event_properties?.name].filter(Boolean))).join(
      ' '
    ),
  ['EVENT', (event) => event]
);
